import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, Route, Switch } from 'react-router-dom';
import * as actions from '../../../store/actions';

import classes from './Index.module.css';

import BlogEntry from '../../../components/Blog/BlogEntry';

class Index extends Component {
    constructor( props ) {
        super( props );
        this.props.onInitBlog();
        if( !this.state.loaded && this.props.match.params.id ) {
            this.setEntry( this.props.match.params.id )
        }
    }

    state = {
        entry: {},
        loaded: false
    }

    setEntry = ( id ) => {
        this.props.onGetBlog( id );
    }

    loadEntry = ( entry ) => {
        window.scrollTo( 0, 0 );
        this.setState( { entry: entry, loaded: true } );
    }

    render () {
        const blogEntriesArray = [];
        for( let i = 0; i < this.props.blogEntries.length - 1; i++ ) {
            blogEntriesArray.push( {
                id: this.props.blogEntries[ i ].id,
                entry: this.props.blogEntries[ i ]
            } );
        }
        let blog = null;
        if( blogEntriesArray.length > 0 ) {
            blog = (
                <div className={classes.Blog}>
                    {
                        blogEntriesArray.map( entry => {
                            return (
                                <div className={classes.Entry}>
                                    <Link onClick={() => this.loadEntry( entry.entry )} to={'/blog/' + entry.id}>
                                        <h1>{entry.entry.title.rendered}</h1>
                                        <img
                                            className={classes.Image}
                                            src={entry.entry._embedded[ "wp:featuredmedia" ][ 0 ].source_url}
                                            alt={entry.entry._embedded[ "wp:featuredmedia" ][ 0 ].title.rendered} />
                                        <p dangerouslySetInnerHTML={{ __html: entry.entry.excerpt.rendered }} />
                                    </Link>
                                </div>

                            )
                        } )
                    }
                </div> )
        }
        let entry = (
            <div>LOADING</div>
        );
        if( this.state.loaded ) {
            entry = (
                <BlogEntry
                    loaded={this.state.loaded}
                    entry={this.state.entry} />

            );
        } else if( this.props.loaded ) {
            entry = (
                <BlogEntry
                    loaded={this.props.loaded}
                    entry={this.props.entry} />
            );
        }
        return (
            <Switch>
                <Route exact path={'/blog/:id'}>
                    {entry}
                </Route>
                <Route exact path={'/blog/'}>
                    {blog}
                </Route>
            </Switch>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onInitBlog: () => dispatch( actions.initBlog() ),
        onGetBlog: ( id ) => dispatch( actions.getBlog( id ) )
    }
}

const mapStateToProps = state => {
    return {
        blogEntries: state.blog.blog,
        entry: state.blog.entry,
        loaded: state.blog.loaded
    }
}

export default connect( mapStateToProps, mapDispatchToProps )( Index );